import { reactive, computed } from '@vue/composition-api';
import { useTeamId } from '@/modules/teamplan/utils/provideTeamId';
import { useProjectsBookmarksListWithSWRV } from '@/modules/teamplan/apis/useProjectsBookmarksListWithSWRV';

export const useTopicBookmarkDropdownMenu = (props: {
  topicId: number;
  notAddedLabel: string;
}) => {
  const teamId = useTeamId();
  const {
    data: projects,
    mutations,
    error,
  } = useProjectsBookmarksListWithSWRV(teamId);

  const state = reactive({
    menu: false,
    createProjectModal: false,
  });

  const buttonInfo = computed(
    (): {
      status: 'loading' | 'error' | 'added' | 'notAdded';
      title: string;
    } => {
      if (!projects.value && error.value) {
        return {
          status: 'error',
          title: '読み込みに失敗しました',
        };
      }

      if (!projects.value) {
        return { status: 'loading', title: '' };
      }

      const addedProjects = projects.value.filter(project =>
        project.topic_bookmarks.some(b => b.topic_id === props.topicId),
      );
      if (addedProjects.length === 0) {
        return { status: 'notAdded', title: props.notAddedLabel };
      }
      if (addedProjects.length === 1) {
        return { status: 'added', title: addedProjects[0].name };
      }
      return { status: 'added', title: '複数のプロジェクト' };
    },
  );

  return {
    teamId,
    projects,
    state,
    buttonInfo,

    addProject: mutations.addProject,
    openWindow: (url: string) => {
      window.open(url);
    },
  };
};
